module.exports = __webpack_public_path__ + "static/CustomHardware-98f9a9679b955d8419086c8c1ae2dac0.png";